import { Injectable } from "@angular/core";
@Injectable()
export class ScriptLoader{

  loadScript($,module){
    $(".after").empty();
    $("#device-breakpoints").remove();

    switch (module){
      case "DASHBOARD":
        this.loadBootstrapDatePicker($);
        break;
      case "CLASSES":
        this.loadBootstrapDatePicker($);
        $(".after").append("<script  async type='text/javascript' src='https://d1hk2frk8zkww3.cloudfront.net/jquery/jquery.timepicker.min.js'></script><script  async type='text/javascript' src='https://mpryvkin.github.io/jquery-datatables-row-reordering/1.2.3/jquery.dataTables.rowReordering.js'></script>")
        break;
      case "ACADEMICS":
        $(".after").append("<script  async type='text/javascript' src='https://d1hk2frk8zkww3.cloudfront.net/jquery/jquery.timepicker.min.js'>");
        this.loadBootstrapDatePicker($);
        break;
    }
  }

  private loadBootstrapDatePicker($){
    $(".after").append("<script>$(document).ready(function() { setTimeout(function(){$('.applyPicker,#admission-dob,#duedateDatePicker1,#duedateDatePicker2,#cheque_date,#dd_date,#termDueDate,#payment-date').datepicker({autoclose:true}); $('#startDate_add,#endDate_add').datepicker({autoclose:true}), $('#duedateDatePicker1,#duedateDatePicker2').datepicker({autoclose:true})},500); });function momentJs(){return moment();};function moment_js(date){return moment(date);}function customToastr(message,type,title){toastr.options.hideDuration = 0;toastr.clear();toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';toastr[type](message, title || '');return 0;}	</"+"script>")
  }
}
